/** Admin bo'limi qobig'i: sarlavha + tablar. Filial menejeri faqat Users'ni ko'radi (02-yechim, 2-band). */
import type { ReactNode } from "react";
import { useLocation, useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import { useMe } from "@/features/auth/hooks";
import { Tabs, type TabItem } from "@/components/ui/tabs";
import { PageHeader } from "@/components/ui/misc";

// label — tarjima kaliti: admin:tabs.<key>
const TABS: (TabItem & { to: string; ownerOnly?: boolean })[] = [
  { key: "users", label: "users", to: "/admin/users" },
  { key: "branches", label: "branches", to: "/admin/branches", ownerOnly: true },
  { key: "settings", label: "settings", to: "/admin/settings", ownerOnly: true },
  { key: "import", label: "import", to: "/admin/import", ownerOnly: true },
  { key: "audit", label: "audit", to: "/admin/audit", ownerOnly: true },
];

export function AdminLayout({ title, subtitle, actions, children }: { title: ReactNode; subtitle?: ReactNode; actions?: ReactNode; children: ReactNode }) {
  const { t } = useTranslation("admin");
  const { t: tc } = useTranslation();
  const me = useMe();
  const navigate = useNavigate();
  const location = useLocation();
  const isOwner = me.data?.role === "owner";
  const items = TABS.filter((t) => isOwner || !t.ownerOnly);
  const active = TABS.find((t) => location.pathname.startsWith(t.to))?.key ?? "users";

  return (
    <div>
      <PageHeader eyebrow={tc("nav.settings")} title={title} subtitle={subtitle} actions={actions}>
        <Tabs
          className="mt-3"
          items={items.map(({ key, label }) => ({ key, label: t(`tabs.${label}`) }))}
          value={active}
          onChange={(key) => {
            const tab = TABS.find((t) => t.key === key);
            if (tab) navigate(tab.to);
          }}
        />
      </PageHeader>
      {children}
    </div>
  );
}
